import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { getDesignations } from '../../actions/userActions/designationAction'
import Loader from '../subComponents/Loader'
import Pagination from '../paginatioin/pagination'
import AddButton from '../subComponents/buttons/AddButton'
import { IconButton,Tooltip } from "@mui/material";
import ServerSideSearch from '../subComponents/search/ServerSideSearch'
import EditButton from '../subComponents/buttons/EditButton'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium'
import DynamicTable from '../reuse_components/DynamicTable'
import BodySmallMedium from '../designSystem/BodySmallMedium'
import Heading6Regular from '../designSystem/Heading6Regular'
import SearchInput from '../subComponents/search/SearchInput'
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import CustomButton from '../subComponents/buttons/CustomButton'
import CustomPagination from '../subComponents/pagination/CustomPagination'
import AddDesignations from './AddDesignations'
import ItemsPerPageSelector from '../subComponents/pagination/ItemsPerPageSelector';
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { Download } from 'lucide-react';
import { downloadDesignation } from "../../actions/userActions/designationAction";
import { t } from '../../locales/translate'
function Designations() {
  const dispatch = useDispatch()
  const history = useHistory()
  const [page, setPage] = useState(1)
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [designationdata, setdesignationdata] = useState([]);
  const designations = useSelector(
    (state) => state.designations_reducer.designations
  )

  const isLoading = useSelector((state) => state.designations_reducer.isDesignationsLoading);

  const totalPages = designations?.totalPages || 0;
  const totalItems = designations?.totalCount || 0;
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };
  const [selected, setSelected] = useState({
    textSearch: '',
  })
  const [filters, setFilters] = useState({
    textSearch: '',
  })
 

  const permissions = JSON.parse(localStorage.getItem('permissionsList'))
  const [query, setQuery] = useState('')
  useEffect(() => {
    const body = {
      filter: filters,
      pageNumber: currentPage,
      pageSize: itemsPerPage,
    };
    dispatch(getDesignations(body));
  }, [currentPage, filters, dispatch]);
  
  const designationData = designations && designations?.result || [];
  const handleItemsPerPageChange = (value) => {
    const body = {
      filter: filters,
      pageNumber: firstPage,
      pageSize: value,
    };
    dispatch(getDesignations(body));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  const handleSearch = (e) => {
    setSelected({ ...selected, ['textSearch']: e.target.value })
    if (e.target.value.length >= 1) {
      setTimeout(() => {
        setFilters({ ...filters, ['textSearch']: e.target.value })
      }, 500)
    }
    if (e.target.value == '') {
      setFilters({ ...filters, ['textSearch']: e.target.value })
    }
  }
 
 useEffect(() => {
  const DesignationData = designationData?.map((designation) => ({
    ...designation,
    colorString: designation.color,
    color: (
      <div style={{ display: 'flex', alignItems: 'center',  }}>
        <div 
          style={{ 
            width: '20px', 
            height: '20px', 
            backgroundColor: designation.color || '#002D72',
          }} 
        />
      </div>
    ),
      status: (
        <span className={designation.active ? "status-badge-active" : "status-badge-inactive"}>
          {designation.active ? "Active" : "Inactive"}
        </span>
      ),
    }));
    setdesignationdata(DesignationData);
  }, [designations]);
  const handleDesignationDownload=()=>{
    dispatch(downloadDesignation());
  };
  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("color")}`, accessor: "color" },
    { label: `${t("description")}`, accessor: "description" },
    { label: `${t("designationLevel")}`, accessor: "levelName" },
    { label: `${t("status")}`, accessor: "status" },  
  ];
 
  const handleAddDesignationClick = () => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEditDesignation = (row) => {
    setEditData(row);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSaveData = async () => {
    const body = {
      filter: filters,
      pageNumber: currentPage,
      pageSize: itemsPerPage,
    };
    dispatch(getDesignations(body));
    setShowModal(false);
  };
   const actions = [  
    {
        label: 'Edit designation',
        icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
        permission: 'CanUpdateDesignation',
        handler:handleEditDesignation,
    },
];

  return (
    <>
      <div>
        <LoadingOverlay isVisible={isLoading} />
      <div className="main-container">
             <div className="content-wrapper">
                <div className="pagination">
                    <SearchInput
                        placeholder="Search"
                        onChange={handleSearch}
              value={selected.textSearch}
                    />
                   <div className="flex-align-center">
                   <div className="items-per-page-container">
                  <ItemsPerPageSelector
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  />
                </div>
                       <CustomPagination
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)} 
                      />
                      <div style={{ paddingRight: '12px' }}>
                        <IconButton onClick={handleDesignationDownload}>
                          <Download />
                        </IconButton>
                      </div>
                    {permissions && permissions.includes("CanAddDesignation") && (
                            <CustomButton text={t("addNew")} onClick={handleAddDesignationClick} />
                        )}
                    </div>
                </div>
              
                  
            </div>
            <DynamicTable
                    data={ designationdata}
                    columns={columns}
                    permissions={permissions}
                    actions={actions}
                    thIcon={thIcon}
                    showPagination={totalItems > 0}
                    currentPage={currentPage}
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                    onItemsPerPageChange={handleItemsPerPageChange}
                />
        </div>
        {showModal && (
        <AddDesignations
          onClose={handleCloseModal}
          editData={editData}
          onSave={handleSaveData}
        />
      )}
      </div>
    </>
  )
}

export default Designations
